<template>
    <CompassFormItem
        :label="$t.__('activities.activitiesFormPanel.reminder')"
        orientation="horizontal"
        inputSize="none"
        size="small"
    >
        <template v-if="displayReminderNotifInApp">
            <span class="typographies-paragraph-small-bold">
                {{ $t.__('common.labels.notification') }}
            </span>
            <div class="reminder-container reminder-inapp">
                <CompassSwitch
                    :value="isInAppReminderEnabled"
                    orientation="left"
                    class="reminder-switch"
                    @click="handleSwitchIsInAppReminderEnabled"
                />
                <CompassSelect
                    :value="tempInAppReminder.delay"
                    menuClass="select-menu-reminder-activity"
                    class="select-reminder"
                    :disabled="!isInAppReminderEnabled"
                    @update:value="
                        (value) => updateActivityReminder(value, ENUM_REMINDER_TYPES.INAPP)
                    "
                >
                    <CompassDropdownSelectOption
                        v-for="reminder in reminderOptions"
                        :key="reminder.value"
                        :label="reminder.label"
                        :value="reminder.value"
                    />
                </CompassSelect>
            </div>
        </template>
        <span class="typographies-paragraph-small-bold">
            {{ $t.__('common.labels.email') }}
        </span>
        <div class="reminder-container">
            <CompassSwitch
                :value="isEmailReminderEnabled"
                orientation="left"
                class="reminder-switch"
                @click="handleSwitchIsEmailReminderEnabled"
            />
            <CompassSelect
                :value="tempEmailReminder.delay"
                menuClass="select-menu-reminder-activity"
                class="select-reminder"
                :disabled="!isEmailReminderEnabled"
                @update:value="(value) => updateActivityReminder(value, ENUM_REMINDER_TYPES.EMAIL)"
            >
                <CompassDropdownSelectOption
                    v-for="reminder in reminderOptions"
                    :key="reminder.value"
                    :label="reminder.label"
                    :value="reminder.value"
                />
            </CompassSelect>
        </div>
    </CompassFormItem>
</template>
<script>
import { toLower } from 'lodash';

const REMINDER_DEFAULT_OPTION = '15min';
const ENUM_REMINDER_TYPES = Object.freeze({
    EMAIL: 'email',
    INAPP: 'inapp',
});
export default {
    props: {
        reminders: {
            type: Array,
            default: () => [],
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
        displayReminderNotifInApp: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            ENUM_REMINDER_TYPES,
            isEmailReminderEnabled: false,
            isInAppReminderEnabled: false,
            reminderOptions: [
                {
                    label: this.$t.__('activities.activitiesFormPanel.reminder_instant'),
                    value: 'instant',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 5,
                            unit: this.$t.__('common.labels.minutes'),
                        }),
                    ),
                    value: '5min',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 15,
                            unit: this.$t.__('common.labels.minutes'),
                        }),
                    ),
                    value: '15min',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 30,
                            unit: this.$t.__('common.labels.minutes'),
                        }),
                    ),
                    value: '30min',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.hour'),
                        }),
                    ),
                    value: '1hour',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.day'),
                        }),
                    ),
                    value: '1day',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.week'),
                        }),
                    ),
                    value: '1week',
                },
                {
                    label: toLower(
                        this.$t.__('activities.activitiesFormPanel.reminder_x_unit_before', {
                            count: 1,
                            unit: this.$t.__('common.labels.month'),
                        }),
                    ),
                    value: '1month',
                },
            ],
            tempEmailReminder: {
                medium: ENUM_REMINDER_TYPES.EMAIL,
                delay: REMINDER_DEFAULT_OPTION,
            },
            tempInAppReminder: {
                medium: ENUM_REMINDER_TYPES.INAPP,
                delay: REMINDER_DEFAULT_OPTION,
            },
        };
    },
    created() {
        this.initializeReminderSettings();
    },
    methods: {
        handleSwitchIsInAppReminderEnabled() {
            this.isInAppReminderEnabled = !this.isInAppReminderEnabled;
            if (!this.isInAppReminderEnabled) {
                const reminders = this.reminders.filter(
                    ({ medium }) => medium !== ENUM_REMINDER_TYPES.INAPP,
                );
                this.$emit('updateActivityReminder', reminders);
            } else {
                this.$emit('updateActivityReminder', [...this.reminders, this.tempInAppReminder]);
            }
        },
        handleSwitchIsEmailReminderEnabled() {
            this.isEmailReminderEnabled = !this.isEmailReminderEnabled;
            if (!this.isEmailReminderEnabled) {
                const reminders = this.reminders.filter(
                    ({ medium }) => medium !== ENUM_REMINDER_TYPES.EMAIL,
                );
                this.$emit('updateActivityReminder', reminders);
            } else {
                this.$emit('updateActivityReminder', [...this.reminders, this.tempEmailReminder]);
            }
        },
        initializeReminderSettings() {
            if (this.isEditMode) {
                this.isEmailReminderEnabled = this.reminders.some(
                    ({ medium }) => medium === ENUM_REMINDER_TYPES.EMAIL,
                );
                this.tempEmailReminder = this.isEmailReminderEnabled
                    ? this.reminders.find(({ medium }) => medium === ENUM_REMINDER_TYPES.EMAIL)
                    : this.tempEmailReminder;
                this.isInAppReminderEnabled = this.reminders.some(
                    ({ medium }) => medium === ENUM_REMINDER_TYPES.INAPP,
                );
                this.tempInAppReminder = this.isInAppReminderEnabled
                    ? this.reminders.find(({ medium }) => medium === ENUM_REMINDER_TYPES.INAPP)
                    : this.tempInAppReminder;
            }
        },
        updateActivityReminder(value, type) {
            if (type === ENUM_REMINDER_TYPES.EMAIL) {
                this.tempEmailReminder = this.formatReminderSelectedOptions(
                    ENUM_REMINDER_TYPES.EMAIL,
                    value,
                );
            } else if (type === ENUM_REMINDER_TYPES.INAPP) {
                this.tempInAppReminder = this.formatReminderSelectedOptions(
                    ENUM_REMINDER_TYPES.INAPP,
                    value,
                );
            }

            const reminders = [];
            if (this.isEmailReminderEnabled) {
                reminders.push(this.tempEmailReminder);
            }
            if (this.isInAppReminderEnabled) {
                reminders.push(this.tempInAppReminder);
            }

            this.$emit('updateActivityReminder', reminders);
        },
        formatReminderSelectedOptions(reminderType, delay) {
            return {
                medium: reminderType,
                delay: delay,
            };
        },
    },
};
</script>
<style scoped lang="scss">
.reminder-container {
    align-items: center;
    display: flex;
    gap: var(--spacing-4);
}
.reminder-inapp {
    margin-bottom: var(--spacing-1);
}
.select-reminder {
    flex-grow: 1;
}
</style>
<style lang="scss">
#compass-dropdown-container {
    .select-menu-reminder-activity {
        z-index: 1001;
    }

    .select-menu-reminder-activity {
        width: fit-content;
    }
}
</style>
